import React from "react";
import {getAirportsByCity, getClimateByCity, getMeasurements, log} from "./Tools";
import {useSelector} from "react-redux";
import {LocationsType, StateBaseType} from "./store";

// function component
function CityHover() {

    //const dispatch = useDispatch();
    //const [captchaPassed, setCaptchaPassed] = useState(false);

    const hoveredCity: any = useSelector<StateBaseType>((state) => state.reducer.hoveredCity);
    const locations: LocationsType = useSelector<StateBaseType, LocationsType>((state) => state.reducer.locations);
    if (!hoveredCity || !hoveredCity.hoveredCity) {
        log('skipped hovercity');
        return null;
    }

    const measurements = getMeasurements();
    let x, y;

    x = hoveredCity.hoveredCityPosition.x - 225;
    if (x < 0) {
        x = hoveredCity.hoveredCityPosition.x + 25;
    }
    if (x + 200 > measurements.width) {
        x = hoveredCity.hoveredCityPosition.x - 100;
    }

    if (measurements.height < (hoveredCity.hoveredCityPosition.y + 200)) {
        y = hoveredCity.hoveredCityPosition.y - 125;
    } else {
        y = hoveredCity.hoveredCityPosition.y + 25;
    }

    const divStyle = {
        top: '' + y + 'px',
        left: '' + x + 'px'
    };

    const airports = getAirportsByCity(hoveredCity.hoveredCity, locations);

    log('render Cityhover');
    return (
        <div className="hoverFlight" style={divStyle}>
            {hoveredCity.hoveredCity}
            <br/><br/>
            Climate:{getClimateByCity(hoveredCity.hoveredCity.split(',')[0], locations)}
            <br/>
            Airport{airports.length > 1 ? 's' : ''}:{airports.join()}
        </div>
    );
}

export default CityHover;
